const map = {
  OrderReconciliation: () => import(/* webpackChunkName: "order-reconciliation" */ '@/views/receivables/OrderReconciliation'), // 订单对账情况表
  OrderShippedGoodsList: () => import('@/views/receivables/OrderShippedGoods/index'), // 发货店铺列表
  OrderShippedGoodsListDetail: () => import('@/views/receivables/OrderShippedGoods/Detail'), // 发货店铺明细
  InTransitBalanceDetailsList: () => import('@/views/receivables/InTransitBalanceDetails/index'), // 在途结算明细列表
  SpecialReceivable: () => import(/* webpackChunkName: "special-receivable" */ '@/views/receivables/SpecialReceivable'), // 特殊应收款
  ClosingRecordsList: () => import(/* webpackChunkName: "closing-records-list" */ '@/views/receivables/ClosingRecords'), // 结账记录列表
  ReconAlipayBillingOrderList: () => import(/* webpackChunkName: "recon-alipay-billing-order-get-list" */ '@/views/receivables/ReconAlipayBillingOrder'), // 支付宝对账账单
  InvoiceRecon: () => import(/* webpackChunkName: "invoice-recon" */ '@/views/receivables/InvoiceRecon'), // 销项发票对账
  InstantRetailCommissionSummary: () => import('@/views/receivables/InstantRetailCommissionSummary') // 即时零售加盟佣金汇总
}

export default map
